"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconBase = _interopRequireDefault(require("../icon-base"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var FaChevronDown = function FaChevronDown(props) {
  return _react.default.createElement(_iconBase.default, props, _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M1683 808l-742 741q-19 19-45 19t-45-19L109 808q-19-19-19-45.5t19-45.5l166-165q19-19 45-19t45 19l531 531 531-531q19-19 45-19t45 19l166 165q19 19 19 45.5t-19 45.5z"
  })));
};
FaChevronDown.defaultProps = {
  viewBox: '0 0 1792 1896.083',
  height: '1em',
  width: '0.9451em'
};
FaChevronDown.displayName = 'FaChevronDown';
var _default = FaChevronDown;
exports.default = _default;